export const dataFormatNumberDecimal = (number, locale = 'en-US') => {

    const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(Number(number));
}